/**
 * DisclosureChevron — the open / closed mark of something that opens in
 * place (a collapsible section band, an account row): down when open, right
 * when closed, in `text.muted`. The icon swaps rather than rotates, so it
 * never reads half-turned, whenever the screen is drawn. Decorative: the
 * control carries `aria-expanded`.
 */
import React from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { tokenVars } from '@turn-connect/ui';

export interface DisclosureChevronProps {
  open: boolean;
  /** Icon size in px (20 in a section band). */
  size?: number;
}

export const DisclosureChevron: React.FC<DisclosureChevronProps> = ({ open, size = 20 }) => {
  const Icon = open ? ChevronDown : ChevronRight;
  return <Icon size={size} strokeWidth={2} aria-hidden style={{ flexShrink: 0, color: tokenVars.text.muted }} />;
};

export default DisclosureChevron;
